import { __assign, __rest } from "tslib";
import React from 'react';
import { Checkbox } from '../Checkbox/Checkbox';
import { CheckGroupBase } from '../internal/CheckGroupBase/CheckGroupBase';
import { useControlledCheckboxGroup } from '../internal/utils/useControlledCheckboxGroup';
import { forwardRefForInputGroup } from '../../internal/forwardInputGroupRef/forwardInputGroupRef';
export var CheckboxGroup = forwardRefForInputGroup(function (_a, ref) {
    var valuesProp = _a.values, defaultValuesProp = _a.defaultValues, onChange = _a.onChange, nameProp = _a.name, restProps = __rest(_a, ["values", "defaultValues", "onChange", "name"]);
    var getOptionProps = useControlledCheckboxGroup({
        values: valuesProp,
        defaultValues: defaultValuesProp,
        changeHandler: onChange,
        componentName: 'CheckboxGroup',
        nameAttribute: nameProp,
    }).getOptionProps;
    var renderOption = function (option) {
        return React.createElement(Checkbox, __assign({}, getOptionProps(option)));
    };
    return (React.createElement(CheckGroupBase, __assign({}, restProps, { name: nameProp, renderOption: renderOption, ref: ref })));
});
//# sourceMappingURL=CheckboxGroup.js.map